import { atom } from "recoil";

export const uiState = atom({
  key: "uiState",
  default: {
    loading: false,
  },
});
